import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Globals} from '../../../../core/services/globals';
import {AbstractListingsSearchComponent} from '../../../../shared/components/listing-search/abstract-listings-search.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'my-toronto-listing-search',
  templateUrl: './toronto-listing-search.component.html',
  styleUrls: ['../../../../shared/components/listing-search/listing-search.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule], // ✅ Add FormsModule here

})
export class TorontoListingsSearchComponent extends AbstractListingsSearchComponent {
  constructor(router: Router, globals: Globals) {
    super(router, globals);
  }

  /**
   * Provide Toronto-specific default areas.
   */
  protected getDefaultAreas(): { name: string; value: string }[] {
    return [
      {name: 'North York', value: 'NORTH_YORK'},
      {name: 'Downtown', value: 'DOWNTOWN'},
      {name: 'Scarborough', value: 'SCARBOROUGH'},
      {name: 'Etobicoke', value: 'ETOBICOKE'},
      {name: 'Midtown', value: 'MIDTOWN'},
      {name: 'York', value: 'YORK'},
    ];
  }
}
